import React from "react";

function UpcomingListView({ datas }) {
  return (
    <div className="UpcomingListView">
      {/* <div className="listUpcoming">
        <div className="upComingImg">
          <img src="image 32 (6).png" alt="showcase" className="mainUpcoming" />
        </div>
        <div className="secondSectionUpcoming">
          <div className="nameSection">
            <div className="d-flex align-items-center">
              <p className="realName">DeGods</p>
              <img src="signed 1.png" alt="tick" className="tick ms-2" />
            </div>
            <p className="petName">Azuki</p>
          </div>
          <div>
            <div className="listSTamp">02h 48m 55s</div>
          </div>
        </div>
      </div> */}

      {datas.sort(()=>.5 - Math.random()).map((e, index) => {
        return (
            <div className="listUpcoming" key={index}>
            <div className="upComingImg">
              <img src={e.mainImg} alt="showcase" className="mainUpcoming" />
            </div>
            <div className="secondSectionUpcoming">
              <div className="nameSection ">
                <div className="d-flex align-items-center">
                  <p className="realName upcomingtext">{e.profileName}</p>
                  <img src="signed 1.png" alt="tick" className="tick ms-2" />
                </div>
                <p className="petName">Azuki</p>
              </div>
              <div>
                <div className="listSTamp">02h 48m 55s</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default UpcomingListView;
